module.exports = __webpack_public_path__ + "img/icon_map_shanchu1.571c8780.svg";